import { useQuery, UseQueryResult } from 'react-query';
import { api } from '../api';
import { ProcedureTemplateOverview } from '../types/procedure';

export type GetProcedureTemplatesResponse = {
    procedureTemplates: ProcedureTemplateOverview[];
    totalItems: number;
};

type UseProcedureTemplatessConfig = {
    search?: string;
    sort?: string;
};

async function getProcedureTemplates({ search, sort }: UseProcedureTemplatessConfig): Promise<GetProcedureTemplatesResponse> {
    const query = `?search=${search}&${sort}`;
    const { data } = await api.get(`/procedures/templates${query}`);
    return data;
}

export function useProcedureTemplates({
    search,
    sort,
}: UseProcedureTemplatessConfig): UseQueryResult<GetProcedureTemplatesResponse, unknown> {
    return useQuery(['procedures-templates', search, sort], () => getProcedureTemplates({ search, sort }), {
        keepPreviousData: true,
        enabled: search !== undefined,
    });
}
